/**
 * Month-by-month date fetches only grey out days a policy can reject up front.
 * `allow` / `warn` leave the day selectable; lead and advance of 0 do not
 * cut the calendar. In that case changing months must not hit the network.
 */
export type CalendarDatePolicy = {
  minLeadMinutes?: number;
  maxAdvanceDays?: number;
  schedule?: {
    clinicHours?: string;
    staffSchedule?: string;
  };
} | null;

export const appointmentCalendarNeedsDateFetch = (
  policy: CalendarDatePolicy,
  doctorId?: string | null
): boolean => {
  if (!policy) return false;
  if (policy.schedule?.clinicHours === 'block') return true;
  if (policy.schedule?.staffSchedule === 'block' && Boolean(doctorId)) return true;
  if ((policy.minLeadMinutes ?? 0) > 0) return true;
  if ((policy.maxAdvanceDays ?? 0) > 0) return true;
  return false;
};
